import { IconLoading } from "../IconLoading";

export interface LoadingProps {
  loading?: boolean;
}

export const Loading: React.FC<LoadingProps> = (props) => {
  const { loading = true } = props;

  return loading ? (
    <div className="loading-mask">
      <IconLoading className="loading" />
    </div>
  ) : null;
};
